export const primaryColor = '#D70000';
export const secondaryColor = '#08A158';
export const textPrimaryColor = '#111827';
export const textSecondaryColor = '#535A68';
export const borderColor = '#E4E7ED';
export const textPlaceholder = '#B7BBC7';
export const warning = '#FF961A';
export const error = '#D70000';
export const info = '#2C73FF';
export const success = '#08A158';
export const warningBg = '#FFF3DC';
export const errorBg = '#FFE0E0';
export const infoBg = '#D0E0FF';
export const successBg = '#E8FFDA';
export const checkList = '#EFFFE4';
export const pink = '#FF4689';
export const darkBlue = '#000080';
export const positive = '#56D800';
